import { Channel, Topic } from "../constants/index.js";
import { MessageBrokerUtils } from "../utils/index.js";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import {
  AccountActionCreators,
  UIActionCreators
} from "../redux/action-creators/index.js";
import { useSelector } from "react-redux";
import { UISelectors } from "../redux/selectors/index.js";

export const useToggleUserarea = () => {
  const userInteracted = useSelector(UISelectors.userInteracted);
  const dispatch = useDispatch();

  useEffect(() => {
    const toggleUserarea = () => {
      console.log("toggleUserarea event catched");

      dispatch(AccountActionCreators.toggleAccountDrawer());
      if (!userInteracted) {
        dispatch(UIActionCreators.userInteracted());
      }
    };

    const toggleUserareaSubscription = MessageBrokerUtils.subscribe({
      channel: Channel.UI,
      topic: Topic.toggleUserArea,
      callback: toggleUserarea
    });

    return () => {
      toggleUserareaSubscription?.unsubscribe();
    };
  }, [dispatch, userInteracted]);
};
